import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import HomeManager from './HomeManager';

class HomeStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return {
      data: null,
      selectedTerms: null
    };
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.HOME_STORE_FETCH_HOT_NOW:
        HomeManager.fetchHotNow();
        return state;

      case ActionTypes.HOME_STORE_FETCH_HOT_NOW_COMPLETED:
        return {
          ...state,
          data: action.home,
        };

      case ActionTypes.HOME_STORE_SET_SELECTED_TERMS:
        return {
          ...state,
          selectedTerms: action.selectedTerms
        }

      case ActionTypes.HOME_STORE_FETCH_TO_COMPLETE:
        HomeManager.fetchToComplete();
        return state;

      case ActionTypes.HOME_STORE_FETCH_TO_COMPLETE_COMPLETED:
        return {
          ...state,
          data: action.home,
        };

      case ActionTypes.HOME_STORE_FETCH_NEVER_SEEN:
        HomeManager.fetchNeverSeen();
        return state;

      case ActionTypes.HOME_STORE_FETCH_NEVER_SEEN_COMPLETED:
        return {
          ...state,
          data: action.home,
        };


      default:
        return state;
    }
  }
}

export default new HomeStore();
